<template>
  <div id="app">  
    <div v-if="auth" >
      <navbar /> 
    </div>
    <div class="container">
        <router-view></router-view>
    </div>  
  </div>
</template>

<script>
import NavBar from './components/shared/navbar/Navbar.vue'
export default {
  name: 'app',
  methods: {
    mostrarRamais () {
      alert('Mostra modal de ramais')
    }
  },
  components: {
    'navbar': NavBar
  },
  data () {
    return {
      auth: ''
    }
  },
  created: function () {
    this.auth = JSON.parse(localStorage.getItem('Usuario')) == null ? false : JSON.parse(localStorage.getItem('Usuario')).Agenda
  }
}
</script>

<style>
body{
  overflow-y: scroll;
} 
.container{
    width: 99% !important;
    max-width: 99% !important;
    min-width: 99% !important;
    margin: 0 auto; 
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 
}
.btn, input[type=date], select, .label, .modal-content, input[type=number], input[type=text] {
  border-radius:0px !important;
} 
  h3{
      padding: 15px 0;
      background: #23527b;
      color:#fff !important;
    }
     thead td{
    padding: 8px 0;
    background: #2d618e;
    color: #fff !important;
    font-size: 15px;
    font-weight: bold;
    }
     table td {
      border-color:#fff;
    }
     tfoot td{ 
    background: #cacaca;
    color: #fff; 
    }
.modal-header {
  background:#23527b;
  color: #fff;
}
.modal-header span {
  color:#ffd3d3;
}
</style>



// WEBPACK FOOTER //
// App.vue?561913c0